module.exports = __webpack_public_path__ + "static/img/phone-tip-01.0871634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/phone-tip-01.png
// module id = EIM8
// module chunks = 1